import * as React from "react"
import { graphql } from "gatsby"
import { mergeSeoSettings, mapPageBlocks } from "@lib/helpers"

import * as sections from '@components/home/sections'
import Layout from "../templates/layout"
import { CoreCapabilitiesBlock } from '../components/capabilities/CoreCapabilitiesBlock';
import { CTALast } from "@mode/components"
import { FinalCta } from "storybook-components/FinalCta";


export default function Homepage({ data }) {
  const {
    homepage: {
      metaTitle: title,
      metaDescription: description,
      metaImage: image,
      blocks
    },
    headerSettings: header,
    footerSettings: footer,
    seoSettings,
    footerCta,
    coreCapabilitiesBlock,
  } = data;
  const seo = mergeSeoSettings(seoSettings, { title, description, image })
  return (
    <Layout mode="dark" header={header} footer={footer} seo={seo}>
      {blocks && mapPageBlocks(blocks, sections)}
      <CoreCapabilitiesBlock {...coreCapabilitiesBlock} paddingTop='$xs' />
      {/* <CTALast {...footerCta} /> */}
      <FinalCta />
    </Layout>
  )
}

export const query = graphql`
  {
    seoSettings {
      title
      description
      keywords
      image {
        ...ImageWithPreview
      }
    }
    coreCapabilitiesBlock {
      eyebrow
      heading
      subheading
      adHocTitle
      adHocIcon {
        ...ImageWithPreview
      }
      adHocLink {
        slug {
          current
        }
      }
      selfServeTitle
      selfServeIcon {
        ...ImageWithPreview
      }
      selfServeLink {
        slug {
          current
        }
      }
      dataVisualizationTitle
      dataVisualizationIcon {
        ...ImageWithPreview
      }
      dataVisualizationLink {
        slug {
          current
        }
      }
      customDataAppsTitle
      customDataAppsIcon {
        ...ImageWithPreview
      }
      customDataAppsLink {
        slug {
          current
        }
      }
      advancedAnalyticsTitle
      advancedAnalyticsIcon {
        ...ImageWithPreview
      }
      advancedAnalyticsLink {
        slug {
          current
        }
      }
      link{
        ...InternalLinkContent
      }
      buttons {
        ...ButtonContent
      }
    }
    footerCta {
      id
      heading
      subheading
      buttons {
        ...ButtonContent
      }
    }
    footerSettings {
      ...FooterContent
    }
    headerSettings {
      ...HeaderContent
    }
    homepage {
      id
      metaTitle
      metaDescription
      metaImage {
        ...ImageWithPreview
      }
      blocks: content {
        blocktype,
        _key,
        ...HomeHeroContent
        ...SectionHeadContent
        ...LogosContent
        ...TestimonialStatContent
        ...HomePlatformContent
        ...TestimonialContent
        ...VideoContent
        ...IconRowContent
        ...TwoColumnRowContent
        ...DeepDiveRowContent
        ...TabbedContentContent
        ...IllustrationHeroContent
        ...AnimationScrollContent
        ...ImageCardRowContent
        ...ProductImageContent
        ...ExpandableCarouselContent
        ...LogoMarqueeContent
        ...FeaturedStoryContent
        ...StoryCardGridContent
        ...GraphicButtonContent
        ...PlatformHeadingContent
        ...StatisticsRowContent
        ...InterstitialCtaContent
        ...InterstitialTwoColumnCtaContent
      }
    }
  }
`
